import { afterEvent, defineGameCard } from '../authoring/index.js';
import { alliedPlants, hasTrait, healUnit, isDamaged, isLiveOnBoard, } from './plant-helpers.js';
/**
 * Плющ-корнеплёт: когда другое своё Растение где-либо на поле действительно
 * восстанавливает здоровье, лечит на 1 все остальные повреждённые свои
 * Растения. Собственные UnitHealed игнорируются, чтобы массовое лечение не
 * создавало цепочку.
 */
export const RootweaverIvyCard = defineGameCard({
    id: 'rootweaver_ivy',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 1, health: 4 },
        traits: ['PLANT'],
    },
    presentation: {
        name: 'Плющ-корнеплёт',
        description: 'Когда другое ваше Растение восстанавливает здоровье, все остальные ваши повреждённые Растения восстанавливают 1 здоровье.',
        glyph: {
            colors: ['#10213A', '#6B913B', '#23401E', '#587D34', '#4F3D23'],
            rows: [
                '..11111.....11111...',
                '.12233311..1323221..',
                '1324223331133322441.',
                '1332241131131122341.',
                '121111..133..1342341',
                '111..33..33...111321',
                '.....42..33......11.',
                '....23.3333.........',
                '....33...53.333.....',
                '.........3333323....',
                '.........33...33....',
                '.........35...3.....',
                '.........35.........',
                '.........55.........',
                '...3.....53.........',
                '...322..153..32.....',
                '....2211553..23.....',
                '.....1115551.3......',
                '....11155551..33....',
                '....111111111.3.....',
            ],
        },
    },
    role: 'playable',
    abilities: [
        // Типизированная подписка на ЛЕЧЕНИЕ (UnitHealed) вместо широкого onAnyEvent (D53+).
        afterEvent({
            abilityId: 'rootweave',
            event: 'UnitHealed',
            when: (ctx, event) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self))
                    return false;
                const healed = ctx.q.instance(event.instanceId);
                return isLiveOnBoard(healed)
                    && healed.id !== self.id
                    && event.sourceId !== self.id
                    && healed.controllerId === self.controllerId
                    && hasTrait(ctx, healed.id, 'PLANT');
            },
            run: (ctx, event) => {
                const self = ctx.self;
                if (!isLiveOnBoard(self))
                    return;
                for (const plant of alliedPlants(ctx, self.controllerId)) {
                    if (plant.id === event.instanceId || !isDamaged(ctx, plant.id))
                        continue;
                    healUnit(ctx, plant.id, 1, self.id);
                }
            },
        }),
    ],
});
//# sourceMappingURL=rootweaver_ivy.js.map